import "./index.scss";
import { useWebApp } from "@vkruglikov/react-telegram-web-app";
import { PageBack } from "components/PageBack";
import { useNavigate } from "react-router-dom";
import screen from "assets/invite/invite-screen.png";
import instgram from "assets/instgram.png";
import telegram from "assets/telegram.png";
import twitter from "assets/twitter.png";
import youtube from "assets/youtube.png";
import copyLink from "assets/invite/copy-link.png";
import more from "assets/invite/more.png";

import { copyClipboard, generateInviteLink } from "utils";
import { useSelector } from "react-redux";
import { AppState } from "reducers";
import { ROUTES } from "routes/config";

export function InviteFriend() {
  const { user } = useSelector((state: AppState) => state.auth);
  const webApp = useWebApp();
  const navigate = useNavigate();

  const inviteFriends = () => {
    const inviteLink = generateInviteLink(user.id);
    const messageToSend = `${inviteLink}`;
    webApp.openLink(
      "https://t.me/share/url?url=" + encodeURIComponent(messageToSend)
    );
  };

  const copyInvite = () => {
    const inviteLink = generateInviteLink(user.id);
    const messageToSend = `${inviteLink}`;
    const link = "https://t.me/share/url?url=" + encodeURIComponent(messageToSend);
    copyClipboard(link);
  }

  return (
    <>
      <div className="invite-container">
        <div className="flex justify-start w-full">
          <PageBack onBack={() => navigate(ROUTES.play)} />
        </div>
        <div className="invite-screen">
          <img src={screen} alt="screen" />
        </div>
        <div className="invite-title">
          <h1 className="text-white text-[36px] font-semibold">
            Invite Friends!
          </h1>
          <p className="text-white text-[12px] font-[Poppins]">
            you and your friend will receive more PDJT
          </p>
        </div>
        <div className="invite-button w-full mx-auto">
          <button
            onClick={inviteFriends}
            className="bg-pdj-red rounded-lg w-full text-white font-semibold py-3"
          >
            Invite Friends
          </button>
        </div>

        <div className="invite-socials">
          <div className="flex flex-col gap-[10px] items-center">
            <button className="bg-white rounded-full items-center flex justify-center text-center w-[33.5px] h-[33.5px]" onClick={() => {
              copyInvite()
            }}>
              <img src={copyLink} className="w-[33.5px] h-[33.5px]" alt="" />
            </button>
            <label className="text-white text-[10px]">Copy Link</label>
          </div>

          <div className="flex flex-col gap-[10px] items-center">
            <a
              href="https://www.instagram.com/pdj_trump"
              rel="noreferrer"
              target="_blank"
            >
              <img src={instgram} className="w-[33.5px] h-[33.5px]" alt="" />
            </a>
            <label className="text-white text-[10px]">Instagram</label>
          </div>

          <div className="flex flex-col gap-[10px] items-center">
            <a
              href="https://twitter.com/pd_jtrump"
              rel="noreferrer"
              target="_blank"
            >
              <img src={twitter} className="w-[33.5px] h-[33.5px]" alt="" />
            </a>
            <label className="text-white text-[10px]">Twitter</label>
          </div>

          <div className="flex flex-col gap-[10px] items-center">
            <a href="https://t.me/Pdjtrump" rel="noreferrer" target="_blank">
              <img src={telegram} className="w-[33.5px] h-[33.5px]" alt="" />
            </a>
            <label className="text-white text-[10px]">Telegram</label>
          </div>
        </div>
      </div>
    </>
  );
}
